import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import React, { useState, useEffect, useRef, useCallback } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Header.css";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import userDefault from "../../Assets/Images/userDefault.jpg";
import convert from "../../Assets/new-menu-icon/convert.png";
import otc from "../../Assets/new-menu-icon/otc.png";
import spot from "../../Assets/new-menu-icon/spot.png";
import p2p from "../../Assets/new-menu-icon/p2p.svg";
import copyTrading from "../../Assets/new-menu-icon/copy-trading.svg";
import futures from "../../Assets/new-menu-icon/futures.png";
import options from "../../Assets/new-menu-icon/options.png";

import aPayment from "../../Assets/new-menu-icon/accept-payments.png";
import rPayment from "../../Assets/new-menu-icon/recurring-payments.png";

import history from "../../Assets/new-menu-icon/history.png";
import report from "../../Assets/new-menu-icon/report.png";

import trade from "../../Assets/new-menu-icon/trade-wallet.png";
import earn from "../../Assets/new-menu-icon/earn-wallet.png";
import portfolio from "../../Assets/new-menu-icon/portfolio-wallet.png";
import web3 from "../../Assets/new-menu-icon/web3-wallet.png";
import deposit from "../../Assets/new-menu-icon/deposit-fait.png";
import withdraw from "../../Assets/new-menu-icon/withdraw-fait.png";
import profile from "../../Assets/new-menu-icon/profile-details.svg";
import profilelight from "../../Assets/new-menu-icon/profile-details-light.svg";
import idverification from "../../Assets/new-menu-icon/identity-verification.svg";
import idverificationlight from "../../Assets/new-menu-icon/identity-verification-light.svg";
import bankdetails from "../../Assets/new-menu-icon/bank-details.svg";
import bankdetailslight from "../../Assets/new-menu-icon/bank-details-light.svg";
import promotion from "../../Assets/new-menu-icon/promotion.svg";
import promotionlight from "../../Assets/new-menu-icon/promotion-light.svg";
import changemode from "../../Assets/new-menu-icon/change-mode.png";
import defaultUserImage from "../../Assets/Images/default.png";
import earnHistory from "../../Assets/new-menu-icon/earn-history.png";
import loanHistory from "../../Assets/new-menu-icon/loans-history.png";
import portfolioHistory from "../../Assets/new-menu-icon/portfolio-history.png";
import paybitoIcon from "../../Assets/Images/paybito.png";
import TourIcon from "@mui/icons-material/Tour";

import Shepherd from "shepherd.js";
import "shepherd.js/dist/css/shepherd.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SettingsIcon from "@mui/icons-material/Settings";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import NotificationsIcon from "@mui/icons-material/Notifications";
// import report from "../../Assets/new-menu-icon/.png"
// import report from "../../Assets/new-menu-icon/.png"
// import report from "../../Assets/new-menu-icon/.png"
// import report from "../../Assets/new-menu-icon/.png"
// import report from "../../Assets/new-menu-icon/report.png"
// import report from "../../Assets/new-menu-icon/report.png"
import FileCopyIcon from "@mui/icons-material/FileCopy";

import HeaderDrawer from "./HeaderDrawer";
import {
  ADDR,
  DEMOBROKERDOMAIN,
  WEBSERVICE,
  deviceLogout,
  getAllBrokerMarkets,
  getExchangeFeaturesCurrency,
  showToast,
  handleDefaultAssetPair,
} from "../../CoreDataService";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ChatPopUp from "../ChatPopUp/ChatPopUp";
import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Button,
  Avatar,
  Badge,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SocialDrawer from "../SocialDrawer/SocialDrawer";
import { ContainedButton } from "../../Common/Buttons";
import GroupIcon from "@mui/icons-material/Group";
import LogoutIcon from "@mui/icons-material/Logout";

export default function Header() {
  // Add state for Ad Center dialog and selected ad

  const googleTranslateInitRef = useRef(false);

  const { btncolor, allColors } = useSelector((state) => state);

  const [showAdDialog, setShowAdDialog] = React.useState(false);
  const [selectedAd, setSelectedAd] = React.useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSocialActivated, setIsSocialActivated] = useState(false);
  const [feature, setFeature] = useState("");

  const theme = localStorage.getItem("theme");
  const childRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const historyReportIcon = (
    // <i className="fa-solid fa-book" style={{ fontSize: "14px" }}></i>
    <WorkHistoryIcon style={{ fontSize: "16px" }} />
  );
  const walletIcon = (
    // <i className="fa-solid fa-wallet" style={{ fontSize: "14px" }}></i>
    <AccountBalanceWalletIcon style={{ fontSize: "16px" }} />
  );

  var [drawerStatus, setDrawerStatus] = useState(false);
  var [fullNavbarStatus, setFullNavbarStatus] = useState(true);
  var [BROKERID, setBrokerId] = useState("");
  var [BROKEREXCHANGENAME, setBrokerExchangeName] = useState("");
  var [brokerWebsite, setBrokerWebsite] = useState(null);
  var [BROKEREXCHANGELOGO, setBrokerExchangeLogo] = useState("");
  var [navbarColor, setNavbarColor] = useState("");

  const [newMessage, setNewMessage] = useState("");
  const dispatch = useDispatch();
  const { brokerMarkets, userProfileImage } = useSelector((state) => state);
  const [dropdowns, setDropdowns] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [profilePic, setProfilePic] = useState(defaultUserImage);
  const [avatar, setAvatar] = useState("https://via.placeholder.com/100");
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [selectedTab, setSelectedTab] = useState("all");
  const [adCenterUnreadCount, setAdCenterUnreadCount] = useState(0);

  const [helpUrlForBrokers, setHelpUrlForBrokers] = useState(
    window.location.origin + "/help/"
  );
  /* const [baseUrlForBrokerPayments, setBaseUrlForBrokerPayments] = useState(
    window.location.origin + "/payments") */
  const [baseUrlForBrokerPayments, setBaseUrlForBrokerPayments] = useState(
    `${window.location.origin
    }/payments/autologin?brokerId=${localStorage.getItem(
      "BROKERID"
    )}&uuid=${localStorage.getItem("uuid")}&token=${localStorage.getItem(
      "access_token"
    )}&platform=exchange`
  );
  const [baseUrlForBrokerICO, setBaseUrlForBrokerICO] = useState(
    window.location.origin + "/ico-contract-owner/login"
  );
  const pageName = location.pathname.split("/").pop();
  const [baseUrlForBrokerNftMarketplace, setBaseUrlForBrokerNftMarketplace] =
    useState(window.location.origin + "/nft-marketplace");

  const handleMouseEnter = (dropdownId) => {
    setDropdowns((prev) => ({ ...prev, [dropdownId]: true }));
  };

  const handleMouseLeave = (dropdownId) => {
    setDropdowns((prev) => ({ ...prev, [dropdownId]: false }));
  };

  const redirectUrl = () => {
    return brokerWebsite.includes("http")
      ? brokerWebsite
      : `https://www.${brokerWebsite}`;
  };

  const handleDropdownClose = (menu) => {
    setDropdowns((prev) => ({ ...prev, [menu]: false }));
  };
  const handleDropdownCloseSmallMenu = () => {
    setIsDropdownOpen(false);
  };

  var navBarDynamicColor = "";
  const [timeLeft, setTimeLeft] = useState(20); // start at 20 seconds
  const intervalRef = useRef(null);

  const startCountdown = () => {
    // clear any existing timer
    if (intervalRef.current) clearInterval(intervalRef.current);

    setTimeLeft(20); // reset to 20 sec
    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // clear interval on unmount
  useEffect(() => {
    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (userProfileImage) {
      const img = new Image();
      img.src = userProfileImage;

      img.onload = () => {
        setProfilePic(userProfileImage);
        // setImageLoaded(true);
      };

      img.onerror = () => {
        setProfilePic(defaultUserImage);
        // setImageLoaded(true);
      };
    }
  }, [userProfileImage]);
  useEffect(() => {
    if (pageName === "spot") {
      getLoginHistory();
    }
    // Cleanup on leaving Spot page
    return () => {
      if (Shepherd.activeTour) {
        Shepherd.activeTour.cancel(); // closes popup immediately
      }
    };
  }, [pageName]);
  // useEffect(() => {

  // }, []);

  useEffect(() => {
    // showHideButtons()
    loadBrokerDataByDomain();

    // console.log("addr", ADDR);

    if (
      localStorage.getItem("access_token") == null ||
      localStorage.getItem("access_token") == "" ||
      localStorage.getItem("access_token") == " "
    ) {
      console.log("access_token", localStorage.getItem("access_token"));

      // getUserDetails();
    } else {
      getUserDetails();
      getNotificationHistory();
      getBrokerExchangeFeatures();
    }
  }, [localStorage.getItem("access_token")]);

  const getBrokerExchangeFeatures = async () => {
    const brokerId = localStorage.getItem("BROKERID");
    try {
      const response = await axios.get(
        `${WEBSERVICE}home/getBrokerExchangeFeatures/${brokerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      console.log("response setting", response);
      setFeature(response?.data?.features);
    } catch (error) {
      console.error("Error fetching API keys", error);
    }
  };

  console.log("btncolor", allColors);

  useEffect(() => {
    // Don't fetch Ad Center data when on the 'exchange-fees' route or when not logged in
    console.log("pageName", pageName);

    if (pageName !== "exchange-fees" && localStorage.getItem("access_token")) {
      getAdCenterData();
    }
  }, [notifications]);

  function openNavDrawer() {
    setDrawerStatus(!drawerStatus);
    // console.log(drawerStatus);
  }
  const showDrawerTab = () => {
    const isParent = localStorage.getItem("parentId");
    let drawerShowStatus = true;
    if (
      isParent == null ||
      isParent == undefined ||
      isParent == "" ||
      isParent == "null"
    ) {
      drawerShowStatus = true;
    } else {
      drawerShowStatus = false;
    }
    return drawerShowStatus;
  };
  async function getUserDetails() {
    if (localStorage.getItem("user_id") && localStorage.getItem("uuid")) {
      const userObj = {
        userId: localStorage.getItem("user_id"),
        uuid: localStorage.getItem("uuid"),
      };
      const userJsonString = JSON.stringify(userObj);
      try {
        const response = await axios.post(
          `${WEBSERVICE}user/GetUserDetails`,
          userJsonString,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `BEARER ${localStorage.getItem("access_token")}`,
            },
          }
        );
        const res = response?.data;
        const pair = res?.defaultAssetPair || res?.userResult?.defaultAssetPair;
        if (pair) {
          handleDefaultAssetPair(pair);
        }

        var phone = res.userResult.phone;
        var phoneCountryCode = res.userResult.countryCode;

        localStorage.setItem("phone", phone);
        localStorage.setItem("phoneCountryCode", phoneCountryCode);

        localStorage.setItem("parentId", res.userResult.parentId);
        localStorage.setItem("userCountry", res.userResult.country);
        if (
          localStorage.getItem("BROKERID") === null ||
          localStorage.getItem("BROKERID") === "null" ||
          localStorage.getItem("BROKERID") === undefined
        ) {
          console.log("brokerId--> 2", res.userResult.brokerId);
          localStorage.setItem("BROKERID", res.userResult.brokerId);
        }
        localStorage.setItem("isFiatDeposit", res.userResult.isFiatDeposit);
        localStorage.setItem("isFiatWithdraw", res.userResult.isFiatWithdraw);

        let obj = {
          convert: res.userResult.convert,
          otc: res.userResult.otc,
          spot: res.userResult.spot,
          futures: res.userResult.futures,
          options: res.userResult.options,
          copyTrade: res.userResult.copyTrade,
          payments: res.userResult.payments,
          ico: res.userResult.ico,
        };

        console.log("SET_USER_INFO", response.data.userResult.profilePic);
        const profilePicName = localStorage.getItem("profile_pic");
        const uuid = localStorage.getItem("uuid");
        const token = localStorage.getItem("access_token");

        if (profilePicName && profilePicName !== "") {
          axios
            .get(
              `${WEBSERVICE}user/${uuid}/file/${response.data.userResult.profilePic}`,
              {
                headers: {
                  "Content-Type": "blob",
                  authorization: `BEARER ${token}`,
                },
                responseType: "blob",
              }
            )
            .then((response) => {
              const reader = new FileReader();
              reader.readAsDataURL(response.data);
              reader.onloadend = () => {
                const result = reader.result;
                setProfilePic(result);
                localStorage.setItem("userProfilePic", result);
                dispatch({ type: "SET_USER_PROFILE_IMAGE", payload: result });
              };
            })
            .catch((error) => {
              console.error("Failed to load profile picture", error);
              setProfilePic(avatar);
              localStorage.setItem("userProfilePic", avatar);
              dispatch({ type: "SET_USER_PROFILE_IMAGE", payload: avatar });
            });
        } else {
          setProfilePic(avatar);
          localStorage.setItem("userProfilePic", avatar);
          dispatch({ type: "SET_USER_PROFILE_IMAGE", payload: avatar });
        }

        dispatch({ type: "SET_USER_INFO", payload: response.data });
        const result = await getAllBrokerMarkets(obj);
        dispatch({ type: "ALL_BROKER_MARKETS", payload: result });
      } catch (err) {
        // if (err?.status === 401) logout();
      }

      // const dataRecheck = response.data;
      // if (dataRecheck.error.error_data === 0) {

      // }
    }
  }
  console.log("brokerMarkets", brokerMarkets);

  const setDemoBrokerId = () => {
    var a = localStorage.getItem("BROKERID");
    if (window.location.origin == DEMOBROKERDOMAIN) {
      localStorage.setItem("DEMOBROKERID", a);
    }
  };

  const launchPayments = () => {
    setDemoBrokerId();
    if (window.location.origin == DEMOBROKERDOMAIN) {
      window.open(`${baseUrlForBrokerPayments}`, "_blank");
    } else {
      window.open(baseUrlForBrokerPayments, "_blank");
    }
  };

  const redirectToIcoContractOwner = (uuid, brokerId) => {
    const targetDomain = window.location.origin; // or your actual domain

    const autoLoginUrl = `${targetDomain}/ico-contract-owner/login?auto_uuid=${encodeURIComponent(uuid)}&auto_brokerId=${encodeURIComponent(brokerId)}`;

    window.open(autoLoginUrl, "_blank", "noopener,noreferrer");
  };

  const launchIco = () => {
    setDemoBrokerId();
    const uuid = localStorage.getItem("uuid");
    const brokerId = localStorage.getItem("BROKERID");
    redirectToIcoContractOwner(uuid, brokerId);
  };

  const launchHcNet = () => {
    window.open("https://paybito.com/hc-net", "_blank");
  };

  const launchBrokers = () => {
    window.open(
      "https://www.paybito.com/crypto-broker-white-label-platform/",
      "_blank"
    );
  };

  const launchNft = () => {
    let obj = {
      userId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
      token: localStorage.getItem("access_token"),
      brokerId: localStorage.getItem("BROKERID"),
    };
    let jsonStr = JSON.stringify(obj);
    let str = btoa(jsonStr);
    // const paybitoUrl = "https://trade.paybito.com/nft-marketplace";
    // console.log(
    //   "baseUrlForBrokerNftMarketplace",
    //   baseUrlForBrokerNftMarketplace,
    //   paybitoUrl,
    //   baseUrlForBrokerNftMarketplace === paybitoUrl
    // );
    // if (baseUrlForBrokerNftMarketplace === paybitoUrl) {
    //   console.log("baseUrlForBrokerNftMarketplace if");
    //   window.open(
    //     "https://paybito.com/nft-marketplace" + "/session/" + str,
    //     "_blank"
    //   );
    // } else {
    console.log("baseUrlForBrokerNftMarketplace else");
    window.open(baseUrlForBrokerNftMarketplace + "/session/" + str, "_blank");
    // }
  };

  // const launchIco = () => {
  // setDemoBrokerId();
  // window.open(baseUrlForBrokerICO, '_blank');
  // }

  const logout = () => {
    // localStorage.clear();
    // navigate("/");
    // window.location.reload();
  };

  const handleChangeTheme = () => {
    const themeColor = localStorage.getItem("theme");

    if (themeColor == "dark") {
      localStorage.setItem("theme", "light");
    } else {
      localStorage.setItem("theme", "dark");
    }
    window.location.reload();
  };

  function getEffectiveDomain() {
    const isInIframe = window.self !== window.top;
    if (isInIframe && document.referrer) {
      try {
        const referrerOrigin = new URL(document.referrer).origin;
        console.log("In iframe, using referrer domain:", referrerOrigin);
        return referrerOrigin;
      } catch (e) {
        console.warn(
          "Failed to parse referrer, falling back to window.location.origin"
        );
      }
    }
    return window.location.origin;
  }

  function getBrokerIdbyDomainName() {
    setIsLoaded(false);
    const domain = getEffectiveDomain();
    axios({
      url: ADDR + "exchangeDetailsByDomain?domain=" + domain + "/",
      method: "GET",
    })
      // Handle the response from backend here
      .then((res) => {
        setIsLoaded(true);
        console.log("Broker details", res.data);

        setBrokerExchangeLogo(res.data.exchangeLogo);
        setBrokerExchangeName(res.data.exchange);
        setBrokerId(res.data.brokerId);

        dispatch({ type: "SET_BROKER_BASIC_INFO", payload: res.data });

        getBrokerDataUsingBrokerId(res.data.brokerId);
      })

      // Catch errors if any
      .catch((err) => { });
  }

  function getBrokerDataUsingBrokerId(brokerId) {
    setIsLoaded(false);

    axios({
      url: ADDR + "getBrokerWiseExchangeInfo?brokerId=" + brokerId,
      method: "GET",
    })
      .then((res) => {
        setIsLoaded(true);

        console.log("Broker more details", res.data);
        const userLang = res.data.language;

        const x = document.getElementById("google_translate_element");

        if (userLang == null) {
          if (x) x.style.display = "block"; // show widget
          setTranslateCookie("en");
          setTimeout(() => {
            googleTranslateElementInit1();
          }, 2000);
        } else {
          if (x) x.style.display = "block"; // ✅ keep it visible
          setTranslateCookie(userLang);
          setTimeout(() => {
            loadGoogleTranslate(userLang);
          }, 2000);
        }

        setBrokerExchangeLogo(res.data.value[0].exchange_logo);
        setBrokerExchangeName(res.data.value[0].exchange);
        setBrokerWebsite(res.data.value[0].company_website || null);
        setBrokerId(res.data.value[0].broker_id);
        if (res.data.socialLogin == 1) {
          setIsSocialActivated(true);
        } else {
          setIsSocialActivated(false);
        }

        setNavbarColor(res.data.color.navbarColor);
        dispatch({ type: "ALL_COLORS", payload: res.data.color });
        console.log("brokerId--> params", brokerId);
        localStorage.setItem("BROKERID", brokerId);
        localStorage.setItem("BROKERID_Domain", brokerId);
        localStorage.setItem("exchange", res.data.value[0].exchange);
        localStorage.setItem("companyName", res.data.value[0].company_name);
        localStorage.setItem("brokerDomain", res.data.domain);
        localStorage.setItem("exchangeLogo", res.data.value[0].exchange_logo);
        getExchangeFeaturesCurrency();
        var basicData = {
          brokerId: res.data.value[0].broker_id,
          code: 1,
          companyName: res.data.value[0].company_name,
          exchange: res.data.value[0].exchange,
          exchangeLogo: res.data.value[0].exchange_logo,
        };

        dispatch({ type: "SET_BROKER_BASIC_INFO", payload: basicData });
        dispatch({ type: "SET_BROKER_DETAILED_INFO", payload: res.data });
      })
      .catch((err) => {
        console.error("Broker data fetch failed", err);
      });
  }

  async function loadBrokerDataByDomain() {
    const isInIframe = window.self !== window.top;
    console.log(
      "api called in loadbroker",
      window.location.origin,
      "isIframe:",
      isInIframe,
      "referrer:",
      document.referrer
    );

    const queryParams = new URLSearchParams(location.search);
    // Check both React Router params and raw window URL params (for iframe scenarios)
    const id =
      queryParams.get("broker-id") ||
      new URLSearchParams(window.location.search).get("broker-id");

    if (id) {
      console.log("In ELSE block: Broker ID =", id);

      setBrokerId(id);
      await getBrokerDataUsingBrokerId(id);
      // Add your ELSE block logic here
    } else {
      const idNew = localStorage.getItem("BROKERID");
      console.log("In IF block: No broker ID present.", idNew);
      // Add your IF block logic here
      if (idNew !== null && idNew !== "null" && idNew !== undefined) {
        await getBrokerDataUsingBrokerId(idNew);
      } else {
        console.log("In IF block: No broker ID present. domainnnn");
        await getBrokerIdbyDomainName();
      }
    }
  }

  useEffect(() => {
    const googleTranslateElementInit = () => {
      if (googleTranslateInitRef.current) return;
      googleTranslateInitRef.current = true;

      const container = document.getElementById("google_translate_element");
      if (container) container.innerHTML = "";

      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        "google_translate_element"
      );

      const targetNode = document.getElementById("google_translate_element");
      if (targetNode) {
        const observer = new MutationObserver(() => {
          const list = document.querySelectorAll(".goog-te-menu-value");

          if (
            list &&
            list.length > 0 &&
            list[0].children &&
            list[0].children.length > 0
          ) {
            if (list[0].children[0].innerText === "Select Language") {
              list[0].children[0].innerText = "English";
            }
          }
        });

        observer.observe(targetNode, {
          childList: true,
          subtree: true,
        });

        return () => observer.disconnect();
      }
    };

    // Load Google Translate script dynamically
    const script = document.createElement("script");
    script.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);
    window.googleTranslateElementInit = googleTranslateElementInit;

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const applyStyles = () => {
      const googleTranslateElement = document.getElementById(
        "google_translate_element"
      );
      document
        .querySelectorAll("iframe.skiptranslate")
        .forEach(function (iframe) {
          iframe.addEventListener("load", function () {
            var body = this.contentWindow.document.body;
            body.setAttribute("scroll", "yes");
            body.style.margin = "0px";
            body.style.overflow = "auto";
          });
          // set the max width of the iframe
          iframe.style.maxWidth = "100%";
        });

      if (googleTranslateElement) {
        const gadgetSimple = googleTranslateElement.querySelector(
          ".goog-te-gadget-simple"
        );
        const gadgetSimpleSecond = googleTranslateElement.querySelector(
          ".VIpgJd-ZVi9od-xl07Ob-lTBxed"
        );

        if (gadgetSimple) {
          gadgetSimple.style.backgroundColor = "transparent";
          gadgetSimple.style.border = "none";

          if (gadgetSimpleSecond) {
            gadgetSimpleSecond.style.color = localStorage.getItem(
              "access_token"
            )
              ? "#a8a1a1"
              : "a8a1a1";
            gadgetSimpleSecond.style.overflow = "auto";
          }
          return true; // Return true if elements are found
        }
      }
      return false; // Return false if elements are not found
    };

    // Set up a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          if (applyStyles()) {
            observer.disconnect(); // Stop observing once styles are applied
          }
        }
      }
    });

    // Start observing the document body for changes
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup the observer on unmount
    return () => observer.disconnect();
  }, [navbarColor, brokerMarkets]);

  function setTranslateCookie(lang) {
    console.log("lang", lang);

    const googTransValue = `/en/${lang}`;
    document.cookie = `googtrans=${googTransValue};path=/;domain=${window.location.hostname};`;
    document.cookie = `googtrans=${googTransValue};path=/;`; // Set both with and without domain
  }

  function hideGoogleTranslateUI() {
    const css = `
      .goog-te-banner-frame, 
      .goog-te-gadget-icon,
      .goog-te-menu-frame, 
      #goog-gt-tt,
      .goog-te-balloon-frame,
      .goog-text-highlight {
          display: none !important;
      }
      body { top: 0px !important; }
    `;
    const style = document.createElement("style");
    style.innerHTML = css;
    document.head.appendChild(style);
  }
  function autoTranslateTo(lang) {
    try {
      const select = document.querySelector(".goog-te-combo");
      if (select) {
        select.value = lang; // e.g. "hi" for Hindi, "fr" for French
        select.dispatchEvent(new Event("change")); // trigger change
      } else {
        console.warn("Google Translate combo not found yet, retrying...");
        setTimeout(() => autoTranslateTo(lang), 500); // retry until it's available
      }
    } catch (err) {
      console.error("autoTranslateTo error:", err);
    }
  }

  function googleTranslateElementInit1() {
    try {
      if (googleTranslateInitRef.current) {
        applyGoogleTranslateFixes();
        return;
      }

      // ✅ Check if google translate script is loaded
      if (
        window.google &&
        window.google.translate &&
        typeof window.google.translate.TranslateElement === "function"
      ) {
        googleTranslateInitRef.current = true;

        const container = document.getElementById("google_translate_element");
        if (container) container.innerHTML = "";

        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            layout:
              window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false,
          },
          "google_translate_element"
        );
      } else {
        console.warn("Google Translate script not loaded yet.");
        return; // safely exit
      }

      const elem = document.getElementById("google_translate_element");
      if (elem) {
        const observer = new MutationObserver(() => {
          try {
            let list = document.querySelectorAll(".goog-te-menu-value");
            if (
              list &&
              list.length > 0 &&
              list[0].children &&
              list[0].children.length > 0
            ) {
              if (list[0].children[0].innerText === "Select Language") {
                list[0].children[0].innerText = "English";
              }
            }
          } catch (err) {
            console.error("MutationObserver error:", err);
          }
        });

        observer.observe(elem, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      setTimeout(() => {
        try {
          let anchor = document.querySelectorAll(
            ".VIpgJd-ZVi9od-xl07Ob-lTBxed"
          );
          console.log("class anchor", anchor);
          if (anchor && anchor[0]) {
            anchor[0].setAttribute("href", "javascript:void(0)");
          }
        } catch (err) {
          console.error("Anchor modification error:", err);
        }
      }, 500);

      document
        .querySelectorAll("iframe.skiptranslate")
        .forEach(function (iframe) {
          try {
            iframe.addEventListener("load", function () {
              try {
                const body = this.contentWindow.document.body;
                if (body) {
                  body.setAttribute("scroll", "yes");
                  body.style.margin = "0px";
                  body.style.overflow = "auto";
                }
              } catch (err) {
                console.error("iframe body modification error:", err);
              }
            });
            iframe.style.maxWidth = "100%";
          } catch (err) {
            console.error("iframe handling error:", err);
          }
        });
    } catch (err) {
      console.error("googleTranslateElementInit1 error:", err);
    }
  }

  function applyGoogleTranslateFixes() {
    try {
      let list = document.querySelectorAll(".goog-te-menu-value");
      if (
        list &&
        list.length > 0 &&
        list[0].children &&
        list[0].children.length > 0
      ) {
        if (list[0].children[0].innerText === "Select Language") {
          list[0].children[0].innerText = "English";
        }
      }

      let anchor = document.querySelector(".VIpgJd-ZVi9od-xl07Ob-lTBxed");
      if (anchor) {
        anchor.setAttribute("href", "javascript:void(0)");
      }

      document.querySelectorAll("iframe.skiptranslate").forEach((iframe) => {
        iframe.addEventListener("load", function () {
          try {
            const body = this.contentWindow.document.body;
            if (body) {
              body.setAttribute("scroll", "yes");
              body.style.margin = "0px";
              body.style.overflow = "auto";
            }
          } catch (err) {
            console.error("iframe body modification error:", err);
          }
        });
        iframe.style.maxWidth = "100%";
      });
    } catch (err) {
      console.error("applyGoogleTranslateFixes error:", err);
    }
  }

  function loadGoogleTranslate(userLang) {
    // If already initialized, just switch language and apply fixes
    if (googleTranslateInitRef.current) {
      autoTranslateTo(userLang);
      applyGoogleTranslateFixes();
      return;
    }

    // Prevent duplicate script injection
    if (document.getElementById("google-translate-script")) {
      autoTranslateTo(userLang);
      applyGoogleTranslateFixes();
      return;
    }

    window.googleTranslateElementInit = function () {
      if (googleTranslateInitRef.current) {
        autoTranslateTo(userLang);
        applyGoogleTranslateFixes();
        return;
      }
      googleTranslateInitRef.current = true;

      const container = document.getElementById("google_translate_element");
      if (container) container.innerHTML = "";

      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: userLang,
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false,
        },
        "google_translate_element"
      );

      // Apply fixes after initialization
      setTimeout(() => {
        autoTranslateTo(userLang);
        applyGoogleTranslateFixes();
      }, 500);
    };
  }

  const getLoginHistory = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) return;

    const logHistoryObj = {
      uuid: localStorage.getItem("uuid"),
      noOfItemsPerPage: 20,
      pageNo: 1,
    };
    try {
      const response = await fetch(WEBSERVICE + "/user/GetLoginHistory", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "BEARER " + token,
        },
        body: JSON.stringify(logHistoryObj),
      });
      if (response.status === 401) return;
      const data = await response.json();
      if (data.loginDetails?.length < 6) {
        openTour();
      }
    } catch (error) {
      console.error("Error fetching login history:", error);
    }
  };

  // const handleLogOutConfirmation = () => {
  //   setShow(true);

  // }

  const handleLogout = () => {
    setShow(false);
    // const url = `/login?broker-id=${BROKERID}`;
    localStorage.clear();
    localStorage.setItem("BROKERID", BROKERID);
    document.cookie = `exchange_token=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=.paybito.com;path=/`;
    navigate("/");
    window.location.reload();
  };

  const openTour = () => {
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: {
          enabled: true,
        },
        classes: "class-1 class-2",
        scrollTo: true,
      },
    });

    const steps = [
      {
        title: "Asset Pair",
        text: "Select the asset pair you would like to trade in",
        attachTo: { element: ".tour1", on: "bottom" },
        scrollTo: false,
      },
      {
        title: "OrderBook Sell",
        text: `<ul><li>This is the Sell side of the Orderbook.</li><li>Sell orders that the traders on the exchange place are displayed here. The orders are sorted by their price. The lowest price is at the bottom and the highest price is at the top.</li><li>If you are a buyer, the best sell orders are the ones that are selling at the lowest price. If you place a buy order, your order will first be fulfiled with the lowest priced Sell order on the orderbook. This is done by the exchange automatically to give you the best deal available on the orderbook</li></ul>`,
        attachTo: { element: ".tour2", on: "right" },
        scrollTo: false,
      },
      {
        title: "Orderbook Buy",
        text: `<ul><li>This is the Buy side of the Orderbook</li><li> Buy orders that the traders on the exchange place are displayed here. The orders are sorted by their price. The highest price is at the top and the lowest price is at the bottom.</li><li>f you are a seller, the best buy orders for you are the ones that are selling at the highest price. If you place a Sell order, your order will first be fulfiled with the highest priced buy order on the orderbook. This is done by the exchange automatically to give you the best deal available on the orderbook. </li></ul>`,
        attachTo: { element: ".tour3", on: "left" },
        scrollTo: false,
      },
      {
        title: "Trade History",
        text: "This is the Trade History section. This shows the list of trades of all traders on the exchange sorted by timestamp with the most recent trade on the top.",
        attachTo: { element: ".tour4", on: "left" },
      },
      {
        title: "Chart",
        text: "This is the Charts section. It shows trades data of the overall exchange. You can view various data such as the opening and closing trade price or highest and lowest trade prices or trading volumes.",
        attachTo: { element: ".tour5", on: "bottom" },
      },

      // {
      //   title: 'Chart Type',
      //   text: 'Click here to change the Chart type...',
      //   attachTo: { element: '.tour-chart-type', on: 'bottom' }
      // },
      // {
      //   title: 'Chart Indicator',
      //   text: 'Click here to choose your Indicator preference...',
      //   attachTo: { element: '.tour7', on: 'bottom' }
      // },

      {
        title: "Buy Order",
        text: "This is where you place a Buy Order in the Spot market. Make the best of the various order types available to execute your trading strategy. Use the slider available to use a specified percentage of your available balance to buy. ",
        attachTo: { element: ".tour8", on: "bottom" },
      },
      {
        title: "Sell Order",
        text: "This is where you place a Sell Order in the Spot market. Make the best of the various order types available to execute your trading strategy. Use the slider available to use a specified percentage of your available balance to sell. ",
        attachTo: { element: ".tour9", on: "bottom" },
      },
      {
        title: "My Trade History",
        text: "Trade History allows you to review the history of your trades on the exchange. ",
        attachTo: { element: ".tour10", on: "top" },
      },
      {
        title: "My Open Orders",
        text: "Open Orders shows you the order that you have open on the exchange.",
        attachTo: { element: ".tour11", on: "top" },
      },
      {
        title: "My Stop Orders",
        text: "Stop Orders shows you the Stop Limit order you have placed on the exchange.",
        attachTo: { element: ".tour12", on: "top" },
      },

      {
        title: "Chat GPT",
        text: "Use the AI Advisor integrated with ChatGPT to ask questions on any topic in trading.",
        attachTo: { element: ".tour14", on: "bottom" },
      },
      {
        title: "My Profile",
        text: "Click here to review your Profile Info, Identity Verification status and Bank Info. Know how to Refer a friend and earn free cryptocurrencies. You can switch to a dark or a light mode view from here. ",
        attachTo: { element: ".tour15", on: "bottom" },
      },
      {
        title: "Settings",
        text: "Go to your Setting from here. <ul><li>Set up your 2FA using Authenticator App or using Phone SMS authentication.</li><li>Update your password. Enable paying transaction fees in HCX and save on trading fees.</li><li> Create API keys for automated trading.</li><li>You can also choose to Deactivate your account from here.</li></ul>",
        attachTo: { element: ".tour16", on: "bottom" },
      },
      {
        title: "My Wallets",
        text: "Access all your fiat and crypto Wallets from here.",
        attachTo: { element: ".tour17", on: "bottom" },
      },
      {
        title: "Language",
        text: "Select your preferred language here. The platform offers you the choice of language from over a 100 languages. ",
        attachTo: { element: ".tour18", on: "bottom" },
      },
      {
        title: "Spot Trading",
        text: "Choose from among the various Spot trading markets available to you.",
        attachTo: { element: ".tour19", on: "bottom" },
      },
      {
        title: "Derivative Trading",
        text: "Choose from among the various Derivative trading markets available to you.",
        attachTo: { element: ".tour20", on: "bottom" },
      },
      {
        title: "Merchant Payments",
        text: `<ul><li>Payments module allows you to accept payments in all top cryptocurrencies. </li><li>Sign up as a merchant and start accepting crypto payment from your website or your retail PoS. </li><li>You can also accept recurring payments from your customers using this product.</li><li>Convert your cryptos received as merchant payments into fiat currencies if you wish.</li></ul>`,
        attachTo: { element: ".tour21", on: "bottom" },
        beforeShowPromise: () => {
          setDrawerStatus(!drawerStatus);
        },
      },
    ];

    if (brokerMarkets?.isBank == 1) {
      steps.push({
        title: "Earn",
        text: "<ul><li>The Earn module allows you to earn passive income on your idle cryptos without risk.</li><li>Earn module works like a savings account earning you interest if you keep in flexible plans.  </li><li>If you go for a lock-in period, it works like a Fixed Deposit earning you more in interest.</li></ul>",
        attachTo: { element: ".tour22", on: "bottom" },
      });
      steps.push({
        title: "Loans",
        text: "The Loan module allows you to get a loan in one crypto asset against another. ",
        attachTo: { element: ".tour23", on: "bottom" },
      });
      steps.push({
        title: "Portfolio",
        text: "The Portfolio module allows you to create a basket of crypto assets and make periodic investments in the basket.",
        attachTo: { element: ".tour24", on: "bottom" },
      });
    }

    steps.push({
      title: "Launch ICO",
      text: "Launch your own ICO using the ICO stage and benefit from the range of ICO services we offer.",
      attachTo: { element: ".tour25", on: "bottom" },
    });

    if (brokerMarkets?.isAssetMgmt == 1) {
      steps.push({
        title: "Asset Management",
        text: "The Asset Management module allows you to delegate your account to groups of expert traders who can trade on your behalf. You have full control on how you delegate the access. ",
        attachTo: { element: ".tour26", on: "bottom" },
      });
    }
    if (brokerMarkets?.isWeb3Wallet == 1) {
      steps.push({
        title: "Web3 Wallet",
        text: "The Web3 Wallet is a decentralized wallet which allows you to store your cryptos on the chain instead of on centralized exchanges.  ",
        attachTo: { element: ".tour27", on: "bottom" },
      });
    }
    if (brokerMarkets?.isHcNet == 1) {
      steps.push({
        title: "HC NET",
        text: "Create decentralized applications on HC NET. Use the power of fast transactions (2-5 sec transfers), high throughput and simplicity of smart contracts to create any decentralized application.",
        attachTo: { element: ".tour28", on: "bottom" },
      });
    }
    if (brokerMarkets?.isMiningPool == 1) {
      steps.push({
        title: "Mining Pool",
        text: "Today you cannot mine alone. Mining alone is expensive and produces low returns. Reaching threshold hash rates is impossible without investing in expensive hardware. You can say goodbye to that problem by joining the Mining Pool. Join the pool and make mining rewarding for you again. ",
        attachTo: { element: ".tour29", on: "bottom" },
      });
    }

    if (brokerMarkets?.isNft == 1) {
      steps.push({
        title: "NFT",
        text: "Create your own NFT or import it to the NFT marketplace. Ask your price or sell your NFT in an auction. Buy special privileges or rare art on the NFT marketplace.",
        attachTo: { element: ".tour30", on: "bottom" },
      });
    }

    steps.push({
      title: "Product Tour",
      text: "Revisit the product tour anytime by clicking here. You need to be on the Spot Market page to see the product tour icon. Click the Logo on the top left corner to get to this page. ",
      attachTo: { element: ".tour31", on: "bottom" },
    });

    steps.forEach((step, index) => {
      tour.addStep({
        id: `step-${index + 1}`,
        title: step.title,
        text: step.text,
        attachTo: step.attachTo,
        scrollTo: step.scrollTo ?? true,
        ...(step.beforeShowPromise && {
          beforeShowPromise: step.beforeShowPromise,
        }),
        buttons: [
          {
            text: "Back",
            action() {
              return this.back();
            },
            classes: "shepherd-button-secondary",
            disabled: index === 0,
          },
          {
            text: index === steps.length - 1 ? "Finish" : "Next",
            action() {
              return index === steps.length - 1 ? this.complete() : this.next();
            },
          },
        ],
      });
    });

    // Start the tour
    tour.start();
  };

  const addHttpsIfMissing = (url) => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return "https://" + url;
    }
    return url;
  };

  // ✅ Fetch notifications
  const getNotificationHistory = useCallback(async () => {
    console.log("in calling fcm token");

    const token = localStorage.getItem("access_token");
    if (!token) return;

    const userObj = {
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await fetch(
        `${WEBSERVICE}notification/notificationHistoryForUsersBrokers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + token,
          },
          body: JSON.stringify(userObj),
        }
      );

      if (response.status === 401) return;

      const dataRecheck = await response.json();

      if (dataRecheck && dataRecheck.result) {
        setNotifications(dataRecheck.result || []);
        // var notifCount = dataRecheck.result.filter((n) => n.isRead === 0).length
        // setUnreadCount(notifCount);
        // getAdCenterData();
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
    }
  }, [WEBSERVICE]);

  useEffect(() => {
    const handleFCMUpdate = () => {
      console.log("📥 New FCM notification received, refreshing...");
      getNotificationHistory();
    };

    window.addEventListener("fcm-notification", handleFCMUpdate);

    return () => {
      window.removeEventListener("fcm-notification", handleFCMUpdate);
    };
  }, [getNotificationHistory]);

  // ✅ Mark as read
  const markAsRead = async (notif) => {
    if (notif.isRead === 0) {
      // call API
      const userObj = {
        dispatchId: notif.id,
      };

      try {
        await fetch(`${WEBSERVICE}notification/markAsRead`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
          body: JSON.stringify(userObj),
        });

        // Refresh list
        getNotificationHistory();
      } catch (err) {
        console.error("Error marking as read:", err);
      }
    }

    console.log("notif.link", notif.link);

    // Open link in new tab if valid
    if (notif.link && notif.link !== "null" && notif.link !== "") {
      const modifiedLink = addHttpsIfMissing(notif.link);
      window.open(modifiedLink, "_blank");
    }
  };

  // ✅ click count ad center
  const modifyClickCountByUser = async (ad) => {
    // if (ad.isRead === 0) {
    // call API
    const userObj = {
      notificationId: ad.notificationId,
      uuid: localStorage.getItem("uuid"),
    };

    try {
      await fetch(`${WEBSERVICE}adCenter/addClickCountByUser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify(userObj),
      });

      // Refresh list
      getNotificationHistory();
    } catch (err) {
      console.error("Error marking as read:", err);
    }
    // }
  };

  // ✅ Filter only unread
  const getOnlyUnread = () => {
    setNotifications((prev) => prev.filter((n) => n.isRead === 0));
  };

  // ✅ Tab select
  const selectTab = (tab) => {
    setSelectedTab(tab);
  };

  // ✅ Ad Center API call
  const [adCenterData, setAdCenterData] = useState([]);
  const getAdCenterData = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) return;

    try {
      const uuid = localStorage.getItem("uuid");
      if (!uuid) return;

      const response = await fetch(
        "https://accounts.paybito.com/api/adCenter/getNotificationDispatchDetails",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${token}`,
          },
          body: JSON.stringify({ uuid }),
        }
      );

      if (response.status === 401) {
        setAdCenterData([]);
        return;
      }

      const data = await response.json();
      if (data.statusCode === 0 && Array.isArray(data.campaignDetails)) {
        setAdCenterData(data.campaignDetails);
        var adCenterCount = data.campaignDetails.filter(
          (n) => n.clickCount === 0
        ).length;
        setAdCenterUnreadCount(adCenterCount);
        var notifCount = notifications.filter((n) => n.isRead === 0).length;
        var lastCount = notifCount + adCenterCount;

        setUnreadCount(lastCount);
      } else {
        setAdCenterData([]);
      }
    } catch (err) {
      setAdCenterData([]);
    }
  };

  // Settings for the carousel
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  // Custom arrow components for the carousel
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", right: 10, zIndex: 1 }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", left: 10, zIndex: 1 }}
        onClick={onClick}
      />
    );
  }

  // Get all media URLs that exist
  const getMediaUrls = () => {
    if (!selectedAd) return [];

    const urls = [];
    for (let i = 1; i <= 6; i++) {
      const mediaKey = `media${i}`;
      if (selectedAd[mediaKey]) {
        urls.push(selectedAd[mediaKey]);
      }
    }
    return urls;
  };

  const mediaUrls = getMediaUrls();
  const isCarousel = selectedAd?.mediaType === "Carousel";

  return (
    <>
      {localStorage.getItem("access_token") && (
        <>
          <ChatPopUp callParent={openTour} />
          {isSocialActivated && <SocialDrawer />}
        </>
      )}

      <Dialog
        open={show}
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            minWidth: { xs: "85%", sm: 400 },
            boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
            overflow: "hidden",
            backgroundColor: "var(--popupbody-color)",
            color: "var(--text-color)",
          },
        }}
      >
        <DialogTitle
          sx={{
            position: "relative",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "1.1rem",
            py: 2.25,
            color: "var(--text-color)",
            backgroundColor: "var(--popupheader-color)",
          }}
        >
          Ready to Leave?
          <IconButton
            onClick={handleClose}
            size="small"
            sx={{
              position: "absolute",
              right: 12,
              top: "50%",
              transform: "translateY(-50%)",
              color: "var(--text-color)",
              opacity: 0.6,
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            textAlign: "center",
            px: 4,
            pt: 3,
            pb: 1,
            backgroundColor: "var(--popupbody-color)",
          }}
        >
          <Typography
            sx={{
              fontSize: "0.95rem",
              color: "var(--text-color)",
              opacity: 0.85,
              lineHeight: 1.6,
            }}
          >
            Select <strong>Log out</strong> below if you are ready to end your
            current session.
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 1.5,
            pb: 3,
            pt: 2,
            backgroundColor: "var(--popupbody-color)",
          }}
        >
          <ContainedButton
            variant="contained"
            onClick={handleClose}
            sx={{
              minWidth: 110,
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Cancel
          </ContainedButton>
          <Button
            variant="contained"
            onClick={handleLogout}
            color="error"
            sx={{
              minWidth: 110,
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Log out
          </Button>
        </DialogActions>
      </Dialog>

      {/* Ad Center Details Dialog */}
      <Dialog
        open={showAdDialog}
        onClose={() => setShowAdDialog(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
            overflow: "hidden",
            backgroundColor: "var(--popupbody-color)",
            color: "var(--text-color)",
          },
        }}
      >
        <DialogTitle
          sx={{
            position: "relative",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "1.05rem",
            py: 2.25,
            color: "var(--text-color)",
            backgroundColor: "var(--popupheader-color)",
          }}
        >
          Ad Center Details
          <IconButton
            onClick={() => setShowAdDialog(false)}
            size="small"
            sx={{
              position: "absolute",
              right: 12,
              top: "50%",
              transform: "translateY(-50%)",
              color: "var(--text-color)",
              opacity: 0.6,
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ px: 3, py: 2.5, backgroundColor: "var(--popupbody-color)" }}
        >
          {selectedAd ? (
            <Box
              sx={{
                backgroundColor: "#000",
                borderRadius: 2,
                p: 2,
                color: "#fff",
                maxWidth: 320,
                mx: "auto",
                boxShadow: 3,
                position: "relative",
              }}
            >
              {/* Header with profile image and name */}
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Avatar
                  src={paybitoIcon}
                  alt="profile"
                  sx={{ width: 32, height: 32, mr: 1 }}
                />
                <Box>
                  <Typography variant="body2" fontWeight="bold" lineHeight={1}>
                    {selectedAd.brokerName || selectedAd.brokerId || "Unknown"}
                  </Typography>
                  <Typography variant="caption" color="gray">
                    @{selectedAd.brokerEmail || "unknown"}
                  </Typography>
                </Box>
              </Box>

              {/* Main ad text */}
              <Typography variant="body2" sx={{ mb: 1 }}>
                {selectedAd.campaignName || "No campaign name"}
              </Typography>

              {/* Campaign description */}
              {selectedAd.campaignDescription && (
                <Typography variant="body2" sx={{ mb: 1 }}>
                  {selectedAd.campaignDescription}
                </Typography>
              )}

              {/* Media display - carousel or single image */}
              {isCarousel && mediaUrls.length > 0 ? (
                <Box sx={{ mb: 2 }}>
                  <Slider {...carouselSettings}>
                    {mediaUrls.map((url, index) => (
                      <Box key={index} sx={{ px: 0.5 }}>
                        <Box
                          component="img"
                          src={url}
                          alt={`ad-media-${index + 1}`}
                          sx={{
                            width: "100%",
                            height: 180,
                            objectFit: "cover",
                            borderRadius: 2,
                          }}
                          onError={(e) => {
                            e.target.src =
                              "https://via.placeholder.com/300x180?text=Image+Not+Available";
                          }}
                        />
                      </Box>
                    ))}
                  </Slider>
                </Box>
              ) : selectedAd?.media1 ? (
                <Box
                  component="img"
                  src={selectedAd.media1}
                  alt="ad-media"
                  sx={{
                    width: "100%",
                    height: 180,
                    objectFit: "cover",
                    borderRadius: 2,
                    mb: 2,
                  }}
                  onError={(e) => {
                    e.target.src =
                      "https://via.placeholder.com/300x180?text=Image+Not+Available";
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: "100%",
                    height: 180,
                    backgroundColor: "#333",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 2,
                    mb: 2,
                  }}
                >
                  <Typography variant="body2" color="text.secondary">
                    No media available
                  </Typography>
                </Box>
              )}

              {/* Website URL */}
              {(selectedAd.websiteUrl || selectedAd.callToActionUrl) && (
                <Typography
                  variant="caption"
                  color="gray"
                  display="block"
                  sx={{ mb: 1 }}
                >
                  {selectedAd.websiteUrl || selectedAd.callToActionUrl}
                </Typography>
              )}

              {/* Promoted tag */}
              <Typography
                variant="caption"
                color="gray"
                display="block"
                sx={{ mb: 1 }}
              >
                🛈 Promoted
              </Typography>

              {/* CTA Button */}
              {(selectedAd.callToActionUrl || selectedAd.websiteUrl) && (
                <ContainedButton
                  variant="contained"
                  size="small"
                  sx={{
                    mt: 1,
                    borderRadius: 1,
                    fontSize: "0.75rem",
                    fontWeight: 500,
                    textTransform: "none",
                  }}
                  onClick={() => {
                    const url =
                      selectedAd.callToActionUrl || selectedAd.websiteUrl;
                    if (url) {
                      window.open(url, "_blank");
                    }
                  }}
                >
                  {selectedAd.callToAction || "Learn More"}
                </ContainedButton>
              )}
            </Box>
          ) : (
            <Typography>No ad selected.</Typography>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            pb: 3,
            pt: 2,
            backgroundColor: "var(--popupbody-color)",
          }}
        >
          <ContainedButton
            variant="contained"
            onClick={() => setShowAdDialog(false)}
            sx={{
              minWidth: 110,
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Close
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Navbar
        expand="lg"
        className=""
        style={{
          background: localStorage.getItem("access_token")
            ? "var(--navbar-color)"
            : allColors?.navbarColor,
          boxShadow: "0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12)",
          padding: "0px",
        }}
      >
        <Container fluid>
          <Navbar.Brand style={{ paddingLeft: "20px" }}>
            <Link to={brokerWebsite ? redirectUrl() : "/spot"}>
              {/* <img alt="" src={BROKEREXCHANGELOGO}
                style={{
                  width: "130px",      // Set max width
                  height: "45px",      // Set max height
                  objectFit: "contain" // Maintain aspect ratio without cropping
                }}
              /> */}
              <div
                style={{
                  width: 130,
                  height: 45,
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {!isLoaded && <CircularProgress size={24} />}

                {isLoaded && (
                  <Box className="image-container">
                    <img
                      src={BROKEREXCHANGELOGO}
                      alt="broker_logo"
                      onLoad={() => setIsLoaded(true)}
                    />
                  </Box>
                )}
              </div>
            </Link>
          </Navbar.Brand>
          {
            <div
              id="google_translate_element"
              className="goog-te-menu-value tour18"
              style={{
                background: localStorage.getItem("access_token")
                  ? "var(--navbar-color)"
                  : allColors?.navbarColor,
              }}
            ></div>
          }
          {localStorage.getItem("access_token") && (
            <>
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                style={{ background: "gray" }}
                className="nav_collapes"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              />
              {fullNavbarStatus ? (
                <Navbar.Collapse
                  id="basic-navbar-nav"
                  className={isDropdownOpen ? "show" : "collapse"}
                  style={{ marginLeft: "5%" }}
                >
                  <Nav
                    className="navbar-nav medium_screen_navbar"
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div title="Trade with basic spot and OTC feature">
                      <NavDropdown
                        title="Trade"
                        id="trade-dropdown"
                        className="tour19"
                        show={dropdowns["trade"]}
                        onMouseEnter={() => handleMouseEnter("trade")}
                        onMouseLeave={() => handleMouseLeave("trade")}
                      >
                        {brokerMarkets?.isConvert === 1 && (
                          <NavDropdown.Item
                            onClick={() => handleDropdownClose("trade")}
                          >
                            <Link
                              to="/convert"
                              className="no-underline"
                              style={{ border: "none" }}
                              title="Trade with ease as a beginner"
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={convert}
                              />
                              <span className="link_items">Convert</span>
                            </Link>
                          </NavDropdown.Item>
                        )}

                        {brokerMarkets?.isSpot === 1 && (
                          <NavDropdown.Item
                            onClick={() => handleDropdownClose("trade")}
                          >
                            <Link
                              to="/spot"
                              className="no-underline"
                              style={{ border: "none" }}
                              title="Simple interface with access to more trading features"
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={spot}
                              />
                              <span className="link_items">Spot</span>
                            </Link>
                          </NavDropdown.Item>
                        )}
                        {brokerMarkets?.isOtc == 1 && (
                          <NavDropdown.Item
                            onClick={() => handleDropdownClose("trade")}
                          >
                            <Link
                              to="/otc"
                              className="no-underline"
                              style={{ border: "none" }}
                              title="Execute large trades at better pricing and enjoy faster settlements"
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={otc}
                              />
                              <span className="link_items">OTC</span>
                            </Link>
                          </NavDropdown.Item>
                        )}
                        {brokerMarkets?.isP2p === 1 && (
                          <NavDropdown.Item
                            onClick={() => handleDropdownClose("trade")}
                          >
                            <Link
                              to="/p2p/dashboard"
                              className="no-underline"
                              style={{ border: "none" }}
                              title="Buy, sell crypto directly with other users with your preferred payment method"
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={p2p}
                              />
                              <span className="link_items">P2P</span>
                            </Link>
                          </NavDropdown.Item>
                        )}
                        {brokerMarkets?.isCopyTrade === 1 && (
                          <NavDropdown.Item
                            onClick={() => handleDropdownClose("trade")}
                          >
                            <Link
                              to="/copy-trade"
                              className="no-underline"
                              style={{ border: "none" }}
                              title="Copy trade the best crypto traders"
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={copyTrading}
                              />
                              <span className="link_items">Copy Trading</span>
                            </Link>
                          </NavDropdown.Item>
                        )}
                      </NavDropdown>
                    </div>
                    {(brokerMarkets?.isFutures !== 0 ||
                      brokerMarkets?.isOptions !== 0) && (
                        <div title="Trade with Derivatives">
                          <NavDropdown
                            title="Derivatives"
                            id="derivatives-dropdown"
                            className="tour20"
                            show={dropdowns["derivatives"]}
                            onMouseEnter={() => handleMouseEnter("derivatives")}
                            onMouseLeave={() => handleMouseLeave("derivatives")}
                          >
                            {brokerMarkets?.isFutures === 1 && (
                              <NavDropdown.Item
                                href="/futures"
                                onClick={() => handleDropdownClose("derivatives")}
                                title="Enjoy higher bottom line and hedge risks in the Futures market"
                              >
                                <img
                                  alt=""
                                  className="headerDropdownImages"
                                  src={futures}
                                />
                                <span className="link_items">Futures</span>
                              </NavDropdown.Item>
                            )}
                            {brokerMarkets?.isOptions === 1 && (
                              <NavDropdown.Item
                                href="/options-chain"
                                onClick={() => handleDropdownClose("derivatives")}
                                title="Trade European vanilla Options"
                              >
                                <img
                                  alt=""
                                  className="headerDropdownImages"
                                  src={options}
                                />
                                <span className="link_items">Options</span>
                              </NavDropdown.Item>
                            )}
                          </NavDropdown>
                        </div>
                      )}
                    {brokerMarkets?.isPayment === 1 && (
                      <div title="Accept crypto merchant payments">
                        <NavDropdown
                          title="Payments"
                          id="payments-dropdown"
                          className="tour21"
                          show={dropdowns["payments"]}
                          onMouseEnter={() => handleMouseEnter("payments")}
                          onMouseLeave={() => handleMouseLeave("payments")}
                        >
                          <NavDropdown.Item
                            onClick={() => (
                              handleDropdownClose("payments"), launchPayments()
                            )}
                          >
                            <Link
                              className="no-underline"
                              style={{ border: "none" }}
                              title="Sign up as a merchant to accept payments in cryptocurrencies"
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={aPayment}
                              />
                              <span className="link_items">
                                Accept Payments
                              </span>
                            </Link>
                          </NavDropdown.Item>
                          <NavDropdown.Item
                            onClick={() => handleDropdownClose("payments")}
                          >
                            <Link
                              to="/recurring-payment"
                              className="no-underline"
                              style={{ border: "none" }}
                              title="Enable recurring payment for a merchant"
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={rPayment}
                              />
                              <span className="link_items">
                                Recurring Payments
                              </span>
                            </Link>
                          </NavDropdown.Item>
                        </NavDropdown>
                      </div>
                    )}
                    {showDrawerTab() && (
                      <div
                        // title="Others features"
                        style={{ position: "relative" }}
                        onMouseEnter={() => setDrawerStatus(true)}
                        onMouseLeave={() => setDrawerStatus(false)}
                      >
                        <Nav.Link>
                          <Box
                            onClick={openNavDrawer}
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 34,
                              height: 34,
                              borderRadius: "9px",
                              mr: "18px",
                              cursor: "pointer",
                              border: drawerStatus
                                ? `1.5px solid ${btncolor || "rgba(125,125,125,0.5)"
                                }`
                                : "1.5px solid rgba(125,125,125,0.25)",
                              backgroundColor: drawerStatus
                                ? `rgba(${parseInt(
                                  (btncolor || "#1976d2").slice(1, 3),
                                  16
                                )},${parseInt(
                                  (btncolor || "#1976d2").slice(3, 5),
                                  16
                                )},${parseInt(
                                  (btncolor || "#1976d2").slice(5, 7),
                                  16
                                )},0.12)`
                                : "transparent",
                              transition: "all 0.18s ease",
                              "&:hover": {
                                border: `1.5px solid ${btncolor || "rgba(125,125,125,0.5)"
                                  }`,
                                backgroundColor: "rgba(125,125,125,0.1)",
                              },
                            }}
                          >
                            <GridViewOutlinedIcon
                              sx={{
                                fontSize: 18,
                                color: "var(--text-color)",
                                transition: "color 0.18s ease",
                              }}
                            />
                          </Box>
                          {drawerStatus ? (
                            <HeaderDrawer
                              navbarColor={navbarColor}
                              setDrawerStatus={setDrawerStatus}
                              brokerMarkets={brokerMarkets}
                              launchIco={launchIco}
                              launchNft={launchNft}
                              launchHcNet={launchHcNet}
                              launchBrokers={launchBrokers}
                            />
                          ) : (
                            ""
                          )}
                        </Nav.Link>
                      </div>
                    )}
                    <div className="d-flex px-2 ms-auto">
                      <div
                        className="d-flex justify-content-around"
                        style={{ width: "160px", marginTop: "4px" }}
                      >
                        <div title="History and Reports">
                          <NavDropdown
                            title={historyReportIcon}
                            id="history-report-dropdown"
                            show={dropdowns["historyReport"]}
                            onMouseEnter={() =>
                              handleMouseEnter("historyReport")
                            }
                            onMouseLeave={() =>
                              handleMouseLeave("historyReport")
                            }
                            style={{ padding: "0px" }}
                          >
                            <NavDropdown.Item
                              onClick={() =>
                                handleDropdownClose("historyReport")
                              }
                            >
                              <Link
                                to="/history"
                                className="no-underline"
                                style={{ border: "none" }}
                                title="Trade history"
                              >
                                <img
                                  alt=""
                                  className="headerDropdownImages"
                                  src={history}
                                />
                                <span className="link_items">
                                  Trade History
                                </span>
                              </Link>
                            </NavDropdown.Item>

                            {brokerMarkets?.isBank === 1 && (
                              <NavDropdown.Item
                                onClick={() =>
                                  handleDropdownClose("historyReport")
                                }
                              >
                                <Link
                                  to="/earn-history"
                                  className="no-underline"
                                  style={{ border: "none" }}
                                  title="Earn history"
                                >
                                  <img
                                    alt=""
                                    className="headerDropdownImages"
                                    src={earnHistory}
                                  />
                                  <span className="link_items">
                                    Earn History
                                  </span>
                                </Link>
                              </NavDropdown.Item>
                            )}

                            {brokerMarkets?.isBank === 1 && (
                              <NavDropdown.Item
                                onClick={() =>
                                  handleDropdownClose("historyReport")
                                }
                              >
                                <Link
                                  to="/loan-history"
                                  className="no-underline"
                                  style={{ border: "none" }}
                                  title="Loan history"
                                >
                                  <img
                                    alt=""
                                    className="headerDropdownImages"
                                    src={loanHistory}
                                  />
                                  <span className="link_items">
                                    Loan History
                                  </span>
                                </Link>
                              </NavDropdown.Item>
                            )}

                            {brokerMarkets?.isBank === 1 && (
                              <NavDropdown.Item
                                onClick={() =>
                                  handleDropdownClose("historyReport")
                                }
                              >
                                <Link
                                  to="/portfolio-history"
                                  className="no-underline"
                                  style={{ border: "none" }}
                                  title="Portfolio history"
                                >
                                  <img
                                    alt=""
                                    className="headerDropdownImages"
                                    src={portfolioHistory}
                                  />
                                  <span className="link_items">
                                    Portfolio History
                                  </span>
                                </Link>
                              </NavDropdown.Item>
                            )}

                            <NavDropdown.Item
                              onClick={() =>
                                handleDropdownClose("historyReport")
                              }
                            >
                              <Link
                                to="/report"
                                className="no-underline"
                                style={{ border: "none" }}
                                title="Reports"
                              >
                                <img
                                  alt=""
                                  className="headerDropdownImages"
                                  src={report}
                                />
                                <span className="link_items">Reports</span>
                              </Link>
                            </NavDropdown.Item>
                          </NavDropdown>
                        </div>
                        <div title="Wallet">
                          <NavDropdown
                            title={walletIcon}
                            id="wallet-dropdown"
                            className="newdropdown tour17"
                            show={dropdowns["wallet"]}
                            onMouseEnter={() => handleMouseEnter("wallet")}
                            onMouseLeave={() => handleMouseLeave("wallet")}
                            style={{ padding: "0px" }}
                          >
                            <NavDropdown.Item
                              onClick={() => handleDropdownClose("wallet")}
                            >
                              <Link
                                to="/my-wallet"
                                className="no-underline"
                                style={{ border: "none" }}
                                title="Trade Wallet"
                              >
                                <img
                                  alt=""
                                  className="headerDropdownImages"
                                  src={trade}
                                />
                                <span className="link_items">Trade Wallet</span>
                              </Link>
                            </NavDropdown.Item>
                            {brokerMarkets?.isBank === 1 && (
                              <NavDropdown.Item
                                onClick={() => handleDropdownClose("wallet")}
                              >
                                <Link
                                  to="/earn-interest-wallet"
                                  className="no-underline"
                                  style={{ border: "none" }}
                                  title="Earn Wallet"
                                >
                                  <img
                                    alt=""
                                    className="headerDropdownImages"
                                    src={earn}
                                  />
                                  <span className="link_items">
                                    Earn Wallet
                                  </span>
                                </Link>
                              </NavDropdown.Item>
                            )}
                            {brokerMarkets?.isBank === 1 && (
                              <NavDropdown.Item
                                onClick={() => handleDropdownClose("wallet")}
                              >
                                <Link
                                  to="/portfolio-wallet"
                                  className="no-underline"
                                  style={{ border: "none" }}
                                  title="Portfolio Wallet"
                                >
                                  <img
                                    alt=""
                                    className="headerDropdownImages"
                                    src={portfolio}
                                  />
                                  <span className="link_items">
                                    Portfolio Wallet
                                  </span>
                                </Link>
                              </NavDropdown.Item>
                            )}
                            {brokerMarkets?.isP2p === 1 && (
                              <NavDropdown.Item
                                onClick={() => handleDropdownClose("wallet")}
                              >
                                <Link
                                  to="/p2p/p2p-wallet"
                                  className="no-underline"
                                  style={{ border: "none" }}
                                  title="P2P Wallet"
                                >
                                  <img
                                    alt=""
                                    className="headerDropdownImages"
                                    src={convert}
                                  />
                                  <span className="link_items">P2P Wallet</span>
                                </Link>
                              </NavDropdown.Item>
                            )}
                            {brokerMarkets?.isWeb3Wallet === 1 && (
                              <NavDropdown.Item
                                onClick={() => handleDropdownClose("wallet")}
                              >
                                <Link
                                  to="/web3-wallet"
                                  className="no-underline"
                                  style={{ border: "none" }}
                                  title="Web3 Wallet"
                                >
                                  <img
                                    alt=""
                                    className="headerDropdownImages"
                                    src={web3}
                                  />
                                  <span className="link_items">
                                    Web3 Wallet
                                  </span>
                                </Link>
                              </NavDropdown.Item>
                            )}
                            <NavDropdown.Item
                              onClick={() => handleDropdownClose("wallet")}
                            >
                              <Link
                                to="/deposit"
                                className="no-underline"
                                style={{ border: "none" }}
                                title="Deposit Fiat"
                              >
                                <img
                                  alt=""
                                  className="headerDropdownImages"
                                  src={deposit}
                                />
                                <span className="link_items">Deposit Fiat</span>
                              </Link>
                            </NavDropdown.Item>
                            <NavDropdown.Item
                              onClick={() => handleDropdownClose("wallet")}
                            >
                              <Link
                                to="/withdraw"
                                className="no-underline"
                                style={{ border: "none" }}
                                title="Withdraw Fiat"
                              >
                                <img
                                  alt=""
                                  className="headerDropdownImages"
                                  src={withdraw}
                                />
                                <span className="link_items">
                                  Withdraw Fiat
                                </span>
                              </Link>
                            </NavDropdown.Item>
                          </NavDropdown>
                        </div>
                        <Nav.Link style={{ padding: "4px" }}>
                          <Link
                            to="/settings"
                            className="no-underline"
                            style={{ border: "none" }}
                            title="Settings"
                          >
                            <SettingsIcon
                              className="tour16"
                              style={{
                                fontSize: "18px",
                                verticalAlign: "middle",
                                color: "var(--text-color)",
                                marginTop: "-6px",
                              }}
                            />

                            {/* <i
                              className="fa-solid fa-gear tour16"
                              style={{ fontSize: "14px", color: "#a8a1a1" }}
                            ></i> */}
                          </Link>
                        </Nav.Link>
                      </div>
                      <NavDropdown
                        title={
                          <>
                            <img
                              className="thumbnail-image-header tour15"
                              src={profilePic}
                              alt="user pic"
                              style={{ marginRight: "5px", width: "27px" }}
                            />
                            <span style={{ fontWeight: "600" }}>
                              {localStorage.getItem("user_name")}
                            </span>
                          </>
                        }
                        id="user-dropdown"
                        className="newdropdown"
                        show={dropdowns["user"]}
                        onMouseEnter={() => handleMouseEnter("user")}
                        onMouseLeave={() => handleMouseLeave("user")}
                      >
                        <NavDropdown.Item
                          onClick={() => handleDropdownClose("user")}
                        >
                          <Link
                            to="/profile-info"
                            className="no-underline"
                            style={{ border: "none" }}
                            title="Profile Info"
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={theme === "dark" ? profile : profilelight}
                            />{" "}
                            <span className="link_items">Profile Info</span>
                          </Link>
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          onClick={() => handleDropdownClose("user")}
                        >
                          <Link
                            to="/identity-verification"
                            className="no-underline"
                            style={{ border: "none" }}
                            title="Identity verification"
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={
                                theme === "dark"
                                  ? idverification
                                  : idverificationlight
                              }
                            />{" "}
                            <span className="link_items">
                              Identity Verification
                            </span>
                          </Link>
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          onClick={() => handleDropdownClose("user")}
                        >
                          <Link
                            to="/bank-details"
                            className="no-underline"
                            style={{ border: "none" }}
                            title="Bank Info"
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={
                                theme === "dark"
                                  ? bankdetails
                                  : bankdetailslight
                              }
                            />{" "}
                            <span className="link_items">Bank Info</span>
                          </Link>
                        </NavDropdown.Item>
                        {feature?.enableReferral === 1 && (
                          <NavDropdown.Item
                            onClick={() => handleDropdownClose("user")}
                          >
                            <Link
                              to="/promotion"
                              className="no-underline"
                              style={{ border: "none" }}
                              title="Refer and Earn"
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={
                                  theme === "dark" ? promotion : promotionlight
                                }
                              />{" "}
                              <span className="link_items">Refer and Earn</span>
                            </Link>
                          </NavDropdown.Item>
                        )}
                        <NavDropdown.Item
                          onClick={() => {
                            handleDropdownClose("user");
                            handleChangeTheme();
                          }}
                          title="Change Mode"
                        >
                          <img
                            alt=""
                            className="headerDropdownImages"
                            src={changemode}
                          />{" "}
                          <span className="link_items">Change Mode</span>
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          onClick={() => (
                            setShow(true), handleDropdownClose("user")
                          )}
                          title="Logout"
                        >
                          <LogoutIcon
                            style={{
                              color: "rgb(181, 181, 181)",
                              fontSize: "16px",
                              verticalAlign: "middle",
                            }}
                          />{" "}
                          <span className="link_items">Logout</span>
                        </NavDropdown.Item>
                      </NavDropdown>
                      <Nav.Link
                        href={helpUrlForBrokers}
                        target="_blank"
                        style={{ padding: "4px" }}
                        title="Support"
                      >
                        {/* <i
                          className="fa-solid fa-question"
                          style={{ fontSize: "11px", color: "#a8a1a1" }}
                        ></i> */}
                        <QuestionMarkIcon
                          style={{
                            fontSize: "18px",
                            color: "var(--text-color)",
                          }}
                        />
                      </Nav.Link>
                      <Nav.Link
                        onClick={() => (
                          setIsDrawerOpen(!isDrawerOpen),
                          setSelectedTab("all"),
                          getNotificationHistory()
                        )}
                        style={{
                          padding: "4px",
                          position: "relative",
                        }}
                        title="Notifications"
                      >
                        {/* <i
                          className="fa fa-bell notify_icon"
                          style={{
                            fontSize: "13px",
                            color: "#a8a1a1",
                            paddingLeft: "10px",
                          }}
                        ></i> */}
                        <NotificationsIcon
                          style={{
                            fontSize: "18px",
                            color: "var(--text-color)",
                          }}
                        />
                        {unreadCount > 0 && (
                          <span className="notifBadge">{unreadCount}</span>
                        )}
                      </Nav.Link>
                      {isDrawerOpen && (
                        <div
                          className={
                            theme == "dark"
                              ? "notifContainerDark"
                              : "notifContainerLight"
                          }
                        >
                          <div className="notifHeader">Notifications</div>

                          {
                            <div
                              className="notifButtonHeader"
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                marginLeft: "0px",
                                marginTop: "0px",
                              }}
                            >
                              <button
                                className={`btn btn-sm ${selectedTab === "all"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                                  }`}
                                onClick={() => (
                                  selectTab("all"), getNotificationHistory()
                                )}
                              >
                                All
                              </button>
                              <button
                                className={`btn btn-sm ${selectedTab === "unread"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                                  }`}
                                style={{ marginLeft: "8px" }}
                                onClick={() => (
                                  selectTab("unread"), getOnlyUnread()
                                )}
                              >
                                Unread
                              </button>
                              <button
                                type="button"
                                className={`btn btn-sm position-relative ${selectedTab === "adCenter"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                                  }`}
                                style={{ marginLeft: "8px" }}
                                onClick={() => {
                                  selectTab("adCenter");
                                  getAdCenterData();
                                }}
                              >
                                Ad Center
                                {adCenterUnreadCount > 0 && (
                                  <span
                                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                    style={{ fontSize: "10px" }}
                                  >
                                    {adCenterUnreadCount}
                                    <span className="visually-hidden">
                                      unread notifications
                                    </span>
                                  </span>
                                )}
                              </button>
                            </div>
                          }

                          {selectedTab === "adCenter" ? (
                            adCenterData.length > 0 ? (
                              <div
                                className="notifItemsContainer"
                                style={{ paddingBottom: "8px" }}
                              >
                                {adCenterData.map((ad, idx) => (
                                  <div
                                    key={idx}
                                    className="notifItem"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setSelectedAd(ad);
                                      setShowAdDialog(true);
                                      modifyClickCountByUser(ad);
                                    }}
                                  >
                                    <div className="notifContent">
                                      {/* Paybito Logo for Ad Center Notification */}
                                      <div className="dotContainer">
                                        {ad.clickCount === 0 && (
                                          <span className="statusDot"></span>
                                        )}
                                      </div>
                                      <div className="notifImageWrapper">
                                        <div className="notifImage">
                                          <img
                                            src={paybitoIcon}
                                            alt="ad-center-paybito-logo"
                                            className="notifImageStyle"
                                          />
                                        </div>
                                      </div>
                                      {/* Text */}
                                      <div className="notifText">
                                        <div className="notifhMsg">
                                          {ad.campaignName}
                                        </div>
                                        <div className="notifMsg">
                                          {ad.campaignDescription}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "32px 16px",
                                  opacity: 0.5,
                                  fontSize: "13px",
                                  color: "var(--text-color)",
                                  gap: "8px",
                                }}
                              >
                                <span style={{ fontSize: "28px" }}>📭</span>
                                No Ad Center Data
                              </div>
                            )
                          ) : notifications.length > 0 ? (
                            <div
                              className="notifItemsContainer"
                              style={{ paddingBottom: "8px" }}
                            >
                              {notifications.map((notif, index) => (
                                <div
                                  key={index}
                                  className="notifItem"
                                  onClick={() =>
                                    markAsRead && markAsRead(notif)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="notifContent">
                                    {/* Dot for unread */}
                                    <div className="dotContainer">
                                      {notif.isRead === 0 && (
                                        <span className="statusDot"></span>
                                      )}
                                    </div>

                                    {/* Image */}
                                    {notif.icon !== null &&
                                      notif.icon !== "" &&
                                      notif.icon !== " " && (
                                        <div className="notifImageWrapper">
                                          <div className="notifImage">
                                            <img
                                              src={notif.icon}
                                              alt="notification"
                                              className="notifImageStyle"
                                            />
                                          </div>
                                        </div>
                                      )}

                                    {/* Text */}
                                    <div className="notifText">
                                      <div className="notifhMsg">
                                        {notif.headline}
                                      </div>
                                      <div className="notifMsg">
                                        {notif.description}
                                      </div>
                                      <div className="notifTime">
                                        {notif.createdOn}
                                      </div>
                                    </div>

                                    {/* Link icon */}
                                    {notif.link !== null &&
                                      notif.link !== "null" &&
                                      notif.link !== "" && (
                                        <div className="dotContainer">
                                          <i
                                            class="fa fa-external-link d-flex align-items-center"
                                            aria-hidden="true"
                                          ></i>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "32px 16px",
                                opacity: 0.5,
                                fontSize: "13px",
                                color: "var(--text-color)",
                                gap: "8px",
                              }}
                            >
                              <span style={{ fontSize: "28px" }}>🔔</span>
                              No Notifications
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </Nav>

                  {isDropdownOpen && (
                    <Nav className="small_screen_navbar">
                      <div className="row">
                        <div className="col-6 col-sm-4 col-md-3 d-flex flex-column align-items-start">
                          {brokerMarkets?.isConvert === 1 && (
                            <Link
                              to="/convert"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={convert}
                              />
                              Convert
                            </Link>
                          )}
                          {brokerMarkets?.isSpot === 1 && (
                            <Link
                              to="/spot"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={spot}
                              />
                              Spot
                            </Link>
                          )}
                          {brokerMarkets?.isOtc === 1 && (
                            <Link
                              to="/otc"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={otc}
                              />
                              OTC
                            </Link>
                          )}
                          {brokerMarkets?.isP2p === 1 && (
                            <Link
                              to="/p2p/dashboard"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={p2p}
                              />
                              &nbsp;P2P
                            </Link>
                          )}
                          {brokerMarkets?.isCopyTrade === 1 && (
                            <Link
                              to="/copy-trade"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={copyTrading}
                              />
                              &nbsp;Copy Trading
                            </Link>
                          )}
                        </div>
                        <div className="col-6 col-sm-4 col-md-3 d-flex flex-column align-items-start">
                          {brokerMarkets?.isFutures === 1 && (
                            <Link
                              to="/futures"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={futures}
                              />
                              Futures
                            </Link>
                          )}
                          {brokerMarkets?.isOptions === 1 && (
                            <Link
                              to="/options-chain"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={options}
                              />
                              Options
                            </Link>
                          )}
                          {brokerMarkets?.isPayment === 1 && (
                            <Link
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={() => (
                                handleDropdownClose("payments"),
                                launchPayments(),
                                handleDropdownCloseSmallMenu()
                              )}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={aPayment}
                              />
                              Accept Payments
                            </Link>
                          )}
                          {brokerMarkets?.isPayment === 1 && (
                            <Link
                              to="/recurring-payment"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={rPayment}
                              />
                              Recurring Payments
                            </Link>
                          )}
                        </div>
                        <div className="col-6 col-sm-4 col-md-3 d-flex flex-column align-items-start mt-2">
                          <Link
                            to="/history"
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={handleDropdownCloseSmallMenu}
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={history}
                            />
                            Trade History
                          </Link>
                          {brokerMarkets?.isBank === 1 && (
                            <Link
                              to="/earn-history"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={earnHistory}
                              />
                              Earn History
                            </Link>
                          )}
                          {brokerMarkets?.isBank === 1 && (
                            <Link
                              to="/loan-history"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={loanHistory}
                              />
                              Loan History
                            </Link>
                          )}
                          {brokerMarkets?.isBank === 1 && (
                            <Link
                              to="/portfolio-history"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={portfolioHistory}
                              />
                              Portfolio History
                            </Link>
                          )}
                          <Link
                            to="/report"
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={handleDropdownCloseSmallMenu}
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={report}
                            />
                            Reports
                          </Link>
                        </div>
                        <div className="col-6 col-sm-4 col-md-3 d-flex flex-column align-items-start">
                          <Link
                            to="/my-wallet"
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={handleDropdownCloseSmallMenu}
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={trade}
                            />
                            Trade Wallet
                          </Link>
                          {brokerMarkets?.isBank === 1 && (
                            <Link
                              to="/earn-interest-wallet"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={earn}
                              />
                              Earn Wallet
                            </Link>
                          )}
                          {brokerMarkets?.isBank === 1 && (
                            <Link
                              to="/portfolio-wallet"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={portfolio}
                              />
                              Portfolio Wallet
                            </Link>
                          )}
                          {brokerMarkets?.isP2p === 1 && (
                            <Link
                              to="/p2p/p2p-wallet"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={convert}
                              />
                              P2P Wallet
                            </Link>
                          )}
                          {brokerMarkets?.isWeb3Wallet === 1 && (
                            <Link
                              to="/web3-wallet"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <img
                                alt=""
                                className="headerDropdownImages"
                                src={web3}
                              />
                              Web3 Wallet
                            </Link>
                          )}
                          <Link
                            to="/deposit"
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={handleDropdownCloseSmallMenu}
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={deposit}
                            />
                            Deposit Fiat
                          </Link>
                          <Link
                            to="/withdraw"
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={handleDropdownCloseSmallMenu}
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={withdraw}
                            />
                            Withdraw Fiat
                          </Link>
                        </div>
                        {/* </div> */}
                        {/* <div className="row"> */}
                        <div className="col-6 col-sm-4 col-md-3 d-flex flex-column align-items-start">
                          {brokerMarkets?.isBank === 1 && (
                            <>
                              <Link
                                to="/earn-interest"
                                className="no-underline"
                                style={{ border: "none" }}
                                onClick={handleDropdownCloseSmallMenu}
                              >
                                <i
                                  className="fa fa-credit-card"
                                  style={{ fontSize: "11px", color: "#a8a1a1" }}
                                ></i>{" "}
                                Earn
                              </Link>
                              <Link
                                to="/crypto-loans"
                                className="no-underline"
                                style={{ border: "none" }}
                                onClick={handleDropdownCloseSmallMenu}
                              >
                                <i
                                  className="fa fa-university"
                                  style={{ fontSize: "11px", color: "#a8a1a1" }}
                                ></i>{" "}
                                Loans
                              </Link>
                              <Link
                                to="/portfolio-invest"
                                className="no-underline"
                                style={{ border: "none" }}
                                onClick={handleDropdownCloseSmallMenu}
                              >
                                <i
                                  className="fa fa-user-circle-o"
                                  style={{ fontSize: "11px", color: "#a8a1a1" }}
                                ></i>{" "}
                                Portfolio
                              </Link>
                            </>
                          )}
                          {brokerMarkets?.isIco === 1 && (
                            <Link
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              {/* <i
                                className="fa fa-clone"
                                style={{ fontSize: "11px", color: "#a8a1a1" }}
                              ></i> */}
                              <FileCopyIcon
                                style={{ fontSize: "11px", color: "#a8a1a1" }}
                              />{" "}
                              Launch ICO
                            </Link>
                          )}
                          {brokerMarkets?.isAssetMgmt === 1 && (
                            <Link
                              to="/asset-management"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <i
                                className="fa fa-briefcase"
                                style={{ fontSize: "11px", color: "#a8a1a1" }}
                              ></i>{" "}
                              Asset Management
                            </Link>
                          )}
                          {brokerMarkets?.isWeb3Wallet === 1 && (
                            <Link
                              to="/web3-wallet"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <i
                                className="fa fa-shopping-bag"
                                style={{ fontSize: "11px", color: "#a8a1a1" }}
                              ></i>{" "}
                              Web3 Wallet
                            </Link>
                          )}
                          {brokerMarkets?.isHcNet === 1 && (
                            <Link
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={() => (
                                launchHcNet(), handleDropdownCloseSmallMenu()
                              )}
                            >
                              <i
                                className="fa fa-signal"
                                style={{ fontSize: "11px", color: "#a8a1a1" }}
                              ></i>{" "}
                              HC NET
                            </Link>
                          )}
                          {brokerMarkets?.isMiningPool === 1 && (
                            <Link
                              to="/mining-pool"
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={handleDropdownCloseSmallMenu}
                            >
                              <i
                                className="fa fa-globe"
                                style={{ fontSize: "11px", color: "#a8a1a1" }}
                              ></i>{" "}
                              Mining Pool
                            </Link>
                          )}
                          {brokerMarkets?.isNft === 1 && (
                            <Link
                              className="no-underline"
                              style={{ border: "none" }}
                              onClick={() => (
                                launchNft(), handleDropdownCloseSmallMenu()
                              )}
                            >
                              <i
                                className="fa fa-picture-o"
                                style={{ fontSize: "11px", color: "#a8a1a1" }}
                              ></i>{" "}
                              NFT
                            </Link>
                          )}
                        </div>

                        <div className="col-6 col-sm-4 col-md-3 d-flex flex-column align-items-start position-relative">
                          <Link
                            className="no-underline"
                            style={{ border: "none" }}
                          />

                          <Link
                            to="/settings"
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={handleDropdownCloseSmallMenu}
                          >
                            {/* <i
                              className="fa-solid fa-gear"
                              style={{ fontSize: "11px", color: "#a8a1a1" }}
                            ></i> */}
                            <SettingsIcon
                              className="tour16"
                              style={{
                                fontSize: "22px",
                                paddingTop: "5px",
                                color: "#a8a1a1",
                              }}
                            />{" "}
                            Settings
                          </Link>
                          <Link
                            to="/profile-info"
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={handleDropdownCloseSmallMenu}
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={profile}
                            />{" "}
                            Profile Info
                          </Link>
                          <Link
                            to="/identity-verification"
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={handleDropdownCloseSmallMenu}
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={idverification}
                            />
                            Identity Verification
                          </Link>
                          <Link
                            to="/bank-details"
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={handleDropdownCloseSmallMenu}
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={bankdetails}
                            />{" "}
                            Bank Info
                          </Link>
                          <Link
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={() => (
                              handleChangeTheme(),
                              handleDropdownCloseSmallMenu()
                            )}
                          >
                            <img
                              alt=""
                              className="headerDropdownImages"
                              src={changemode}
                            />
                            Change Mode
                          </Link>
                          <Link
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={() => setShow(true)}
                          >
                            <i
                              className="fa fa-sign-out"
                              aria-hidden="true"
                              style={{
                                color: "#b5b5b5",
                                fontSize: "14px",
                                padding: "0 3px",
                              }}
                            ></i>
                            Logout
                          </Link>
                          <Link
                            to={helpUrlForBrokers}
                            className="no-underline"
                            style={{ border: "none" }}
                            onClick={handleDropdownCloseSmallMenu}
                          >
                            {/* <i
                              className="fa-solid fa-question"
                              style={{ fontSize: "11px", color: "#a8a1a1" }}
                            ></i> */}
                            <QuestionMarkIcon
                              style={{
                                fontSize: "22px",
                                color: "#a8a1a1",
                              }}
                            />{" "}
                            help
                          </Link>
                          <Link
                            onClick={() => (
                              setIsDrawerOpen(!isDrawerOpen),
                              setSelectedTab("all"),
                              getNotificationHistory()
                            )}
                            className="no-underline"
                            style={{ border: "none", position: "relative" }}
                          >
                            {/* <i
                              className="fa fa-bell notify_icon"
                              style={{ fontSize: "11px", color: "#a8a1a1" }}
                            ></i> */}
                            <NotificationsIcon
                              style={{
                                fontSize: "22px",
                                color: "#a8a1a1",
                              }}
                            />{" "}
                            {unreadCount > 0 && (
                              <span className="notifBadge">{unreadCount}</span>
                            )}
                          </Link>
                          {isDrawerOpen && (
                            <div
                              className={
                                theme == "dark"
                                  ? "notifContainerDark"
                                  : "notifContainerLight"
                              }
                            >
                              <div className="notifHeader">
                                <span className="notifTitle">
                                  Notifications
                                </span>
                              </div>

                              {
                                <div
                                  className="notifButtonHeader"
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    marginLeft: "34px",
                                    marginTop: "5px",
                                  }}
                                >
                                  <button
                                    className={`btn btn-sm ${selectedTab === "all"
                                      ? "btn-primary"
                                      : "btn-outline-primary"
                                      }`}
                                    onClick={() => (
                                      selectTab("all"), getNotificationHistory()
                                    )}
                                  >
                                    All
                                  </button>
                                  <button
                                    className={`btn btn-sm ${selectedTab === "unread"
                                      ? "btn-primary"
                                      : "btn-outline-primary"
                                      }`}
                                    style={{ marginLeft: "8px" }}
                                    onClick={() => (
                                      selectTab("unread"), getOnlyUnread()
                                    )}
                                  >
                                    Unread
                                  </button>
                                  <button
                                    type="button"
                                    className={`btn btn-sm position-relative ${selectedTab === "adCenter"
                                      ? "btn-primary"
                                      : "btn-outline-primary"
                                      }`}
                                    style={{ marginLeft: "8px" }}
                                    onClick={() => {
                                      selectTab("adCenter");
                                      getAdCenterData();
                                    }}
                                  >
                                    Ad Center
                                    {adCenterUnreadCount > 0 && (
                                      <span
                                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                        style={{ fontSize: "10px" }}
                                      >
                                        {adCenterUnreadCount}
                                        <span className="visually-hidden">
                                          unread notifications
                                        </span>
                                      </span>
                                    )}
                                  </button>
                                </div>
                              }

                              {selectedTab === "adCenter" ? (
                                adCenterData.length > 0 ? (
                                  <div className="notifItemsContainer">
                                    {adCenterData.map((ad, idx) => (
                                      <div
                                        key={idx}
                                        className="notifItem"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          setSelectedAd(ad);
                                          setShowAdDialog(true);
                                          modifyClickCountByUser(ad);
                                        }}
                                      >
                                        <div className="notifContent">
                                          {/* Paybito Logo for Ad Center Notification */}
                                          <div className="dotContainer">
                                            {ad.clickCount === 0 && (
                                              <span className="statusDot"></span>
                                            )}
                                          </div>
                                          <div className="notifImageWrapper">
                                            <div className="notifImage">
                                              <img
                                                src={paybitoIcon}
                                                alt="ad-center-paybito-logo"
                                                className="notifImageStyle"
                                              />
                                            </div>
                                          </div>
                                          {/* Text */}
                                          <div className="notifText">
                                            <div className="notifhMsg">
                                              {ad.campaignName}
                                            </div>
                                            <div className="notifMsg">
                                              {ad.campaignDescription}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <div
                                    className="d-flex"
                                    style={{
                                      justifyContent: "center",
                                      fontSize: "13px",
                                      marginTop: "10px",
                                    }}
                                  >
                                    No Ad Center Data
                                  </div>
                                )
                              ) : notifications.length > 0 ? (
                                <div className="notifItemsContainer">
                                  {notifications.map((notif, index) => (
                                    <div
                                      key={index}
                                      className="notifItem"
                                      onClick={() =>
                                        markAsRead && markAsRead(notif)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div className="notifContent">
                                        {/* Dot for unread */}
                                        <div className="dotContainer">
                                          {notif.isRead === 0 && (
                                            <span className="statusDot"></span>
                                          )}
                                        </div>

                                        {/* Image */}
                                        {notif.icon !== null &&
                                          notif.icon !== "" &&
                                          notif.icon !== " " && (
                                            <div className="notifImageWrapper">
                                              <div className="notifImage">
                                                <img
                                                  src={notif.icon}
                                                  alt="notification"
                                                  className="notifImageStyle"
                                                />
                                              </div>
                                            </div>
                                          )}

                                        {/* Text */}
                                        <div className="notifText">
                                          <div className="notifhMsg">
                                            {notif.headline}
                                          </div>
                                          <div className="notifMsg">
                                            {notif.description}
                                          </div>
                                          <div className="notifTime">
                                            {notif.createdOn}
                                          </div>
                                        </div>

                                        {/* Link icon */}
                                        {notif.link !== null &&
                                          notif.link !== "null" &&
                                          notif.link !== "" && (
                                            <div className="dotContainer">
                                              <i
                                                class="fa fa-external-link d-flex align-items-center"
                                                aria-hidden="true"
                                              ></i>
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <div
                                  className="d-flex"
                                  style={{
                                    justifyContent: "center",
                                    fontSize: "13px",
                                    marginTop: "10px",
                                  }}
                                >
                                  No Notification
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </Nav>
                  )}
                </Navbar.Collapse>
              ) : (
                ""
              )}
            </>
          )}
        </Container>
      </Navbar>
    </>
  );
}
